import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'agencies',
            name: 'agency',
            class: 'Modules\\Site\\Entities\\Agency'
        }
    }
}